import { restDelete, restGet, restPost, restPut } from "apiCommandsExecutor/rest";

import { ModifierSetDto } from "./restModels";
import { ModifierSetRequestDto } from "./restRequests";

// ===== Наборы модификаторов (REST /api/rest/warehouse/v1) =====
// Заведение бэк берёт из аккаунта — organizationBranchId в запросах не передаём.

export const getModifierSets = () => restGet<ModifierSetDto[]>("/modifier-sets");

export const createModifierSet = (body: ModifierSetRequestDto) =>
    restPost<ModifierSetDto>("/modifier-sets", body);

export const updateModifierSet = (modifierSetId: number, body: ModifierSetRequestDto) =>
    restPut<ModifierSetDto>(`/modifier-sets/${modifierSetId}`, body);

// Удаление возвращает оставшиеся наборы — клиенту не нужен второй запрос.
export const deleteModifierSet = (modifierSetId: number) =>
    restDelete<ModifierSetDto[]>(`/modifier-sets/${modifierSetId}`);
